import React, { useState } from 'react';

import { getCookie } from 'functions/getCookie';
import { getConfig } from 'functions/getConfig';
import { IconButtonContainer, ButtonIcon } from './styles';
import { buttonIds } from 'components/FreecodePage/FreecodeLayoutConstants';
import Tour from 'components/Tour/tour';
import TOUR_DATA from './tourDataFreecode';

export default function TourButton({ isDarkMode, layout }) {
  const [completed, setCompleted] = useState(getCookie('fsFreecodeTourDone'));

  const setTourCookie = (value) =>
    (document.cookie = `fsFreecodeTourDone=${value}; Domain=${
      getConfig().COOKIE
    }; Max-Age=31536000; Path=/; SameSite=Lax`);

  const toggleTour = (newValue) => {
    setCompleted(newValue);
    if (newValue) {
      setTourCookie(true);
    } else {
      setTourCookie('');
    }
  };

  return (
    <>
      <IconButtonContainer title="Toggle the editor tour" onClick={() => toggleTour(!completed)}>
        <ButtonIcon icon="fa fa-question" id={buttonIds.helpButton}></ButtonIcon>
      </IconButtonContainer>
      {!completed && (
        <Tour
          tourData={TOUR_DATA}
          completed={completed}
          setCompleted={() => toggleTour(!completed)}
          isDarkMode={isDarkMode}
          layout={layout}
        />
      )}
    </>
  );
}
